import { defineComponent } from "vue";

import { COMPONENT_NAME } from "./attributes";
import { WalletFilterType } from "@/shared/repository/modules/wallet/enums";

export default defineComponent({
  name: COMPONENT_NAME,
  props: {
    userId: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      balance: 0,
      email: "",
      isLoading: true,
      error: false,
      balanceInterval: null as ReturnType<typeof setInterval> | null,
    };
  },
  computed: {
    displayedBalance(): string {
      return this.balance.toFixed(2);
    },

    displayedEmail(): string {
      if (this.isLoading && !this.email) {
        return "...";
      }
      return this.email || `${this.label.toLowerCase()}@email.com`;
    },

    displayedTooltip(): string {
      if (this.label === "IN") {
        return this.$t(
          "Кошелек IN — это когда юзер ПРОДАЕТ нам USDT. IN — НАМ пришли USDT, НАМ нужно обменять на фиат."
        );
      }
      if (this.label === "OUT") {
        return this.$t(
          "Кошелек OUT — юзер покупает USDT. OUT — МЫ отдаем USDT, перед акцептом транзакции проверь баланс OUT."
        );
      }
      return "";
    },
  },
  async created() {
    await Promise.all([this.loadBalance(), this.loadEmail()]);
    this.balanceInterval = setInterval(() => {
      this.loadBalance();
    }, 60000); 
  },
  beforeUnmount() {
    if (this.balanceInterval) {
      clearInterval(this.balanceInterval);
      this.balanceInterval = null;
    }
  },
  methods: {
    async loadBalance(): Promise<void> {
      this.isLoading = true;
      this.error = false;
     
      try {
        const wallets = await this.$projectServices.walletRepository.list(
          WalletFilterType.all,
          this.userId
        );
        const usdtWallet = wallets.find(
          (wallet) => wallet.name === "USDT" || wallet.currency?.name === "USDT"
        );
        this.balance = usdtWallet?.amount || 0;
      } catch (error) {
        console.error(`Error loading ${this.label} balance:`, error);
        this.error = true;
      } finally {
        this.isLoading = false;
      }
    },

    async loadEmail(): Promise<void> {
      try {
        const users = await this.$projectServices.adminUsersRepository.users();
        const user = users.find((u) => u.id === this.userId);

        if (user) {
          this.email = user.email;
        }
      } catch (error) {
        console.error(`Error loading ${this.label} email:`, error);
      }
    },
  },
});
